/**
 * version을 비교하는 함수
 *
 * `version1` > `version2`이면 `1`
 *
 * `version1` < `version2`이면 `-1`
 *
 * `version1` = `version2`이면 `0`
 */
export const compareAppVersion = (version1: string, version2: string) => {
  const v1 = parseVersion(version1);
  const v2 = parseVersion(version2);

  if (v1.major > v2.major) return 1;
  if (v1.major < v2.major) return -1;

  if (v1.minor > v2.minor) return 1;
  if (v1.minor < v2.minor) return -1;

  if (v1.patch > v2.patch) return 1;
  if (v1.patch < v2.patch) return -1;

  return 0;
};

export const parseVersion = (version: string) => {
  const versionFormat = /^(\d+).(\d+).(\d+)$/;
  const match = versionFormat.exec(version);
  if (!match) {
    throw new Error('version is not valid.');
  }

  const [, major, minor, patch] = match;
  return {
    major: Number.parseInt(major!),
    minor: Number.parseInt(minor!),
    patch: Number.parseInt(patch!),
  };
};
